import { render, staticRenderFns } from "./ListCustomers.vue?vue&type=template&id=0b81493a"
import script from "./ListCustomers.vue?vue&type=script&lang=js"
export * from "./ListCustomers.vue?vue&type=script&lang=js"
import style0 from "./ListCustomers.vue?vue&type=style&index=0&id=0b81493a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports